import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardComponent as InstallerDashboardComponent } from 'src/app/modules/installer/dashboard/dashboard.component';
import { ProfileViewComponent } from 'src/app/components/profile-view/profile-view.component';
import { ProfileEditComponent } from 'src/app/components/profile-edit/profile-edit.component';
import { ChangePasswordComponent } from 'src/app/components/change-password/change-password.component';
import { CustomerDashboardComponent } from '../installer/dashboard/customer-dashboard/customer-dashboard.component';
import { DeviceDashboardComponent } from '../installer/dashboard/device-dashboard/device-dashboard.component';
const routes: Routes = [
  {path:"", component:DashboardComponent},
  {path:"view/installer/dashboard",component:InstallerDashboardComponent},
  {path:"view/installer/dashboard/customer",component:CustomerDashboardComponent},
  {path:"profile",component:ProfileViewComponent},
  {path:"edit/profile",component:ProfileEditComponent},
  {path:"change/password",component:ChangePasswordComponent},
  {path:"view/installer/dashboard/device",component:DeviceDashboardComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
